import { MInstalmentDetail } from 'pages/avia/minstalment/minstalment-detail'

import { mplusStore } from 'entities/mplus/module/mplus-store'

const MInstalment = () => {
  const mInstalmentInfo = mplusStore.getMInstalmentInfo()

  return (
    <MInstalmentDetail
      payNow={mInstalmentInfo?.payNow}
      countMonth={mInstalmentInfo?.countMonth}
      monthlyPrice={mInstalmentInfo?.monthlyPrice}
      onPaymentMInstalment={() => {}}
    />
  )
}

export default MInstalment
